import { useMemo } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { Marker, Popup, useMapEvents } from "react-leaflet";
import { divIcon, DomEvent, icon } from "leaflet";

import { Box, Button, Card, Stack, Typography } from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { changePointPosition, removePoint } from "Redux/pointsSlice";
import DestinationIcon from "Assets/Images/drop-pin-10077.svg";
import { LOGO } from "Configs/core";

const ICON_SIZE = 65;

export default function Pin() {
  const dispatch = useAppDispatch();

  return (
    <div>
      <img src={DestinationIcon} alt="logo" style={{ width: "3vw", height: "4vh" }} />
    </div>
  );
}
